import { useChatStore } from '@/stores/chatStore';
import Spinner from '@/components/ui/Spinner';

export default function MapLoadingOverlay() {
  const isLoading = useChatStore((s) => s.isLoading);
  const reasoning = useChatStore((s) => s.reasoning);

  if (!isLoading) return null;

  return (
    <div className="absolute inset-0 bg-bg-primary/60 backdrop-blur-sm z-[500] flex items-center justify-center pointer-events-none">
      <div className="bg-bg-secondary/90 border border-border-strong rounded-xl px-6 py-4 flex items-center gap-3 shadow-xl max-w-[300px]">
        <Spinner size="sm" />
        <span className="text-sm text-text-muted truncate">
          {reasoning || 'Procesando consulta...'}
        </span>
      </div>
    </div>
  );
}
